import Helpers from '../Helpers'
import XHRPromise from 'xhr-promise'
import { Promise } from 'q';

class ResultsSorting {
    constructor(changeEvent) {
        this.changeEvent = changeEvent
        this.control = document.querySelector('.results-list__sort-by-dropdown')
        this.toggle = document.querySelector('.results-list__sort-by-toggle')
        
        this.listeners()
    }

    get defaultSort() {
        return this.control.getAttribute('data-defaultvalue')
    }
    set defaultSort(value) {
        this.control.setAttribute('data-defaultvalue', value)
    }

    get sort() {
        return this.control.getAttribute('data-value')
    }

    set sort(value) {
        this.control.setAttribute('data-value', value)
    }

    get buttons() {
        return Array.from(this.control.getElementsByClassName('button'))
    }

    listeners() {
        // listener for when option is selected. 
        // Update ui, raise event and hide picker accordion
        new Helpers(this.control).eventListener((e) => {
            this.sort = e.target.value
            // interim update of toggle text - will be overwritten once the search is performed.
            this.toggle.innerText = e.target.innerText
            // hide the menu
            new Helpers(this.control).removeClass('accordion--active')
            new Helpers(this.toggle).removeClass('accordion-toggle--active')
            // raise the sorting event
            this.changeEvent('sorting')
        });

        // any body click not on the accordion toggle should close the accordion too
        new Helpers(document.getElementsByTagName('body')).eventListener((e) => {
            if (e.target !== this.toggle) {
                new Helpers(this.control).removeClass('accordion--active')
                new Helpers(this.toggle).removeClass('accordion-toggle--active')
            }
        })

        new Helpers(this.toggle).eventListener(() => {
            // highlight the active sort
            this.buttons.forEach(b => b.setAttribute('aria-current', b.value === this.sort))
        })
    }


    updateSortControl(data) {
        this.toggle.innerText = data.getAttribute('currentSortTitle')
        this.defaultSort = data.getAttribute('defaultSort')
        this.sort = data.getAttribute('currentSort')

        // set list options
        this.control.innerHTML = ''
        Array.from(data.getElementsByTagName('sortOption')).forEach((so) => {
            const button = document.createElement('button')
            button.className = 'button'
            button.setAttribute('value', so.getAttribute('name'))
            button.setAttribute('aria-current', so.getAttribute('name') === this.sort)
            button.innerText = so.getAttribute('title')
            const li = document.createElement('li')
            li.appendChild(button)
            this.control.appendChild(li)
        })
    }

    setValues(values) {
        this.sort = values.sorting || this.defaultSort
    }

    buildQsForFeed(values) {
        return Object
            .keys(values)
            .filter(v => values[v] !== null && values[v] !== '')
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(values[key])}`)
            .join('&')
    }

    getValues() {
        let values = {}
        values.sorting = this.sort
        return values
    }
    getNonDefaultValues() {
        // return sort if not the default value
        const values = this.getValues()
        Object.keys(values).forEach((key) => (values[key] === this.defaultSort) && delete values[key])
        return values
    }

}
export default ResultsSorting